export default __webpack_public_path__ + "img/bd078609e020383c3fe4a0599552cf78.svg";